module.exports = __webpack_public_path__ + "static/img/bottomNav.0b3cf878.png";